import React from 'react';

import PropTypes from 'prop-types';
import { IconButton, Close } from '@tds/core-interactive-icon';

import {
  Backdrop,
  ModalMain,
  ModalInner,
  ModalMessageMain,
  ModalCancel,
  ModalHeading
} from './css';

const ConfirmationBox = ({
  open,
  hideCloseButton,
  setOpen,
  header,
  children,
  onClose
}) => {
  const handleModalClose = () => {
    setOpen();
    onClose();
  };
  return (
    open && (
      <Backdrop>
        <ModalMain>
          <ModalInner>
            <ModalMessageMain>
              {header && <ModalHeading>{header}</ModalHeading>}
              {children}
            </ModalMessageMain>
            {!hideCloseButton && (
              <ModalCancel>
                <IconButton
                  icon={Close}
                  onClick={handleModalClose}
                  a11yText="Close"
                />
              </ModalCancel>
            )}
          </ModalInner>
        </ModalMain>
      </Backdrop>
    )
  );
};

ConfirmationBox.propTypes = {
  open: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  header: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func
};

ConfirmationBox.defaultProps = {
  open: false,
  hideCloseButton: false,
  header: '',
  onClose: () => {}
};
export default ConfirmationBox;
